import type * as ProjectPageViewTypes from '../../state/views/projectPage/types';
import {
  EMPTY_PANEL_BANK_CONFIG,
  EMPTY_PANEL_BANK_SECTION_CONFIG_FOR_REPORT,
} from '../../util/panelbankConfigs';
import * as Section from '../../util/section';
import {getLinePlotTemplateValues} from '../WorkspaceTemplate/runLinePlots/useLinePlotSections';
import {getWorkspaceLayoutTemplateValues} from '../WorkspaceTemplate/workspaceLayout/useWorkspaceLayoutSections';
import {type WorkspaceTemplate} from '../WorkspaceTemplate/workspaceTemplatesQueries';

function defaultConfig(andOrEnabled?: boolean): Section.Config {
  return {
    openRunSet: 0,
    runSets: [Section.emptyRunSetSelectAll(andOrEnabled)],
    panelBankConfig: EMPTY_PANEL_BANK_CONFIG,
    panelBankSectionConfig: EMPTY_PANEL_BANK_SECTION_CONFIG_FOR_REPORT,
    customRunColors: {},
    workspaceSettings: {},
  };
}

function defaultMultiRunViewSpec(
  andOrEnabled?: boolean
): ProjectPageViewTypes.ProjectPageViewSpec {
  return {
    vizExpanded: false,
    libraryExpanded: true,
    section: defaultConfig(andOrEnabled),
  };
}

export const createMultiRunDefaultSpec = (
  workspaceTemplate: WorkspaceTemplate | undefined,
  andOrEnabled?: boolean
): ProjectPageViewTypes.ProjectPageViewSpec => {
  const config = defaultConfig(andOrEnabled);
  return {
    ...defaultMultiRunViewSpec(andOrEnabled),
    section: {
      ...config,
      workspaceSettings: {
        linePlot: {
          ...getLinePlotTemplateValues(workspaceTemplate),
        },
        ...getWorkspaceLayoutTemplateValues(workspaceTemplate),
      },
    },
  };
};
